import { getArticleWorkflowDetail, useQuery } from "wasp/client/operations";
import { Button, Dialog } from "../../../components/ui";

const ArticleDetailDrawer = ({
  articleId,
  onClose,
}: {
  articleId: number | null;
  onClose: () => void;
}) => {
  const { data, isLoading } = useQuery(
    getArticleWorkflowDetail,
    { articleId: articleId ?? -1 },
    { enabled: articleId !== null },
  );

  return (
    <Dialog
      open={articleId !== null}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      title="Article diagnostics"
      description="Diagnostics stay in a secondary detail view so the hot queue remains summary-first."
      className="max-w-2xl"
      showCloseButton
    >
      {isLoading && (
        <p className="text-sm text-neutral-600 dark:text-neutral-400">
          Loading article details...
        </p>
      )}
      {!isLoading && data && (
        <div className="flex flex-col gap-4">
          <div>
            <h4 className="text-base font-semibold text-black dark:text-white">
              {data.title}
            </h4>
            <p className="text-sm text-neutral-600 dark:text-neutral-400">
              {data.summary}
            </p>
          </div>
          <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
            <div className="rounded-sm border border-stroke p-4 dark:border-strokedark">
              <p className="text-xs uppercase tracking-wide text-neutral-500 dark:text-neutral-400">
                Extraction status
              </p>
              <p className="mt-2 text-sm font-medium text-black dark:text-white">
                {data.articleContent?.extractionStatus ?? "missing"}
              </p>
            </div>
            <div className="rounded-sm border border-stroke p-4 dark:border-strokedark">
              <p className="text-xs uppercase tracking-wide text-neutral-500 dark:text-neutral-400">
                Retry diagnostics
              </p>
              <p className="mt-2 text-sm text-black dark:text-white">
                {data.articleContent?.extractionError ??
                  "No extraction errors recorded."}
              </p>
            </div>
          </div>
          <div className="flex justify-end">
            <Button
              type="button"
              variant="outline"
              tone="neutral"
              size="sm"
              className="rounded-sm"
              onClick={onClose}
            >
              Close
            </Button>
          </div>
        </div>
      )}
    </Dialog>
  );
};

export default ArticleDetailDrawer;
